import { UserResponse } from "../models/UserResponse.js";

const API_ENDPOINT = "https://script.google.com/macros/s/AKfycbwdqs-qegKTUujxyPqu6PUOSnewBvPoWJuqijOawGs0HV2-mDc0KJZry35fV5iYoa8u/exec";

export const sendOtpRequest = async (userRequest) => {
    try {
        const formData = new URLSearchParams();
        formData.append("email", userRequest.email);
        formData.append("apiKey", userRequest.apiKey);
        formData.append("requestType", userRequest.requestType);

        const response = await fetch(API_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return new UserResponse(true, "Request successful", data);
    } catch (error) {
        console.error("Error checking account lock status:", error);
        return new UserResponse(false, error.message);
    }
};

export const verifyOtpRequest = async (userRequest) => {
    try {
        const formData = new URLSearchParams();
        formData.append("email", userRequest.email);
        formData.append("apiKey", userRequest.apiKey);
        formData.append("requestType", userRequest.requestType);
        formData.append("inputOtp", userRequest.inputOtp);

        const response = await fetch(API_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return new UserResponse(true, "Request successful", data);
    } catch (error) {
        console.error("Error checking account lock status:", error);
        return new UserResponse(false, error.message);
    }
};
